<template>
  <div class="referral">
    <div>
      <div class="subheading grey--text mt-6 ml-6"><h5>Overview</h5></div>
      <div class="mt-2 mx-3">
        <v-layout row wrap class="mt-2">
          <CurrentPrice
            v-if="receivedSmsPrices"
            :price="receivedSmsPrices.records[0].price"
          />
          <CreditBalance />
          <SentSMS />
          <SenderId />
        </v-layout>
        <!-- Last 24hrs -->
        <SmsPrice
          v-if="receivedSmsPrices"
          :prices="receivedSmsPrices.records"
        />
      </div>
    </div>
  </div>
</template>

<script>
import io from "socket.io-client";
// import ProgressCircular from "@/components/shared/ProgressCircular.vue";
import CurrentPrice from "@/components/overview/CurrentPrice";
import CreditBalance from "@/components/overview/CreditBalance";
import SentSMS from "@/components/overview/SentSMS";
import SenderId from "@/components/overview/SenderId";
import SmsPrice from "@/components/overview/SmsPrice";
export default {
  components: {
    // ProgressCircular,
    CurrentPrice,
    CreditBalance,
    SentSMS,
    SenderId,
    SmsPrice,
  },
  mounted() {
    const socket = io("https://flybysms-backend-v1-ldlr.onrender.com");
    socket.on("connect", () => {
      console.log("Connected to server via socket.io");
    });

    socket.on("newRecord", () => {
      this.$store.dispatch("sms/fetchSmsPrices", 1);
    });
  },
  created() {
    this.$store.dispatch("sms/fetchSmsPrices", 1);
  },
  computed: {
    receivedSmsPrices() {
      return this.$store.getters["sms/sms"];
    },
  },
};
</script>
